import styled from "@emotion/styled";

import { fontAngkor } from "shared/lib/styles";

import { Button } from "scmp-app/components/posties/button";

import GroundMobileImage from "./ground-mobile.svg?url";
import GroundImage from "./ground.svg?url";

export const Container = styled.div``;

export const Wrapper = styled.div`
  position: relative;
  z-index: 1;

  display: flex;
  flex-direction: column;
  align-items: center;

  max-inline-size: 414px;
  margin-block-start: 56px;
  margin-inline: 24px;

  ${props => props.theme.breakpoints.up("desktop")} {
    display: block;

    margin-block-start: 64px;
    margin-inline: 48px;
  }
`;

export const Title = styled.div`
  margin-block-end: 24px;

  color: #1b4191;
  font-weight: 400;
  font-size: 24px;
  font-family: ${fontAngkor};
  line-height: 28.8px;
  letter-spacing: -0.03em;
  text-align: center;

  ${props => props.theme.breakpoints.up("desktop")} {
    font-size: 36px;
    line-height: 43.2px;
    text-align: start;
  }
`;

export const StyledButton = styled(Button)`
  inline-size: 154px;
  padding-block: 14px 16px;
  padding-inline: 24px;

  font-size: 18px;
  line-height: 18px;
  letter-spacing: 0.03em;

  ${props => props.theme.breakpoints.up("desktop")} {
    padding-block: 14px 16px;
    padding-inline: 24px;

    font-size: 18px;
    line-height: 18px;
    letter-spacing: 0.03em;
  }
`;

export const ImageGround = styled.div`
  position: absolute;
  inset-block-end: -2px;

  inline-size: 100%;

  background-image: url(${GroundMobileImage});
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  aspect-ratio: 332/335;

  ${props => props.theme.breakpoints.up("desktop")} {
    background-image: url(${GroundImage});
    aspect-ratio: 672/332;
  }
`;

export const ImagePeterContainer = styled.div`
  position: absolute;
  inset-block-start: 15%;
  inset-inline-start: 50%;

  block-size: 53%;

  transform: translateX(-50%);

  aspect-ratio: 287/218;

  ${props => props.theme.breakpoints.up("desktop")} {
    inset-block-start: -20%;
    inset-inline: auto 7.05px;

    block-size: 86.73%;
    max-inline-size: none;

    transform: translateX(0);
    aspect-ratio: 399.88/289.67;
  }
`;

export const ImagePeter = styled.img`
  inline-size: 100%;
  block-size: 100%;
`;
